var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ny-logincode",on:{"click":_vm.hide}},[_c('img',{attrs:{"src":_vm.login_code}})])}
var staticRenderFns = []

export { render, staticRenderFns }